import { Link } from "react-router-dom";

const values = [
  {
    icon: "ri-speed-line",
    title: "极速速递",
    desc: "热点响应最快 12 小时，第一时间锁定圈内新鲜事并整理上线。",
  },
  {
    icon: "ri-eye-line",
    title: "真实客观",
    desc: "坚持事实核实与多方信源比对，为每一则圈内动态负责。",
  },
  {
    icon: "ri-vip-crown-line",
    title: "全景覆盖",
    desc: "明星、综艺、影视、红人全栏目覆盖，吃瓜不再东奔西跑。",
  },
];

export default function About() {
  return (
    <section id="about" className="mx-auto max-w-7xl px-4 py-14 md:px-6">
      <div className="grid items-center gap-10 lg:grid-cols-2">
        <div className="relative">
          <div className="overflow-hidden rounded-2xl">
            <img
              src="https://readdy.ai/api/search-image?query=Friendly%20content%20editorial%20team%20working%20in%20a%20bright%20modern%20newsroom%20with%20screens%20showing%20entertainment%20news%2C%20warm%20natural%20light%2C%20collaborative%20atmosphere%2C%20editorial%20photography&width=900&height=640&seq=about-main-01&orientation=portrait"
              alt="吃瓜视频网编辑部工作场景"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-5 -right-4 hidden rounded-2xl bg-primary-500 px-6 py-4 text-background-50 shadow-sm sm:block">
            <p className="font-heading text-2xl font-bold">4600+</p>
            <p className="text-xs text-background-50/85">条圈内速递已上线</p>
          </div>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">About Us</p>
          <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于吃瓜视频网
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-600">
            吃瓜视频网是一个专注于娱乐八卦与圈内速递的视频资讯平台。我们相信，追星吃瓜不该是一件费力的事——把明星动态、综艺高光、影视花絮和红人新作聚在一起，让大家用一个入口就能轻松掌握娱乐圈的全貌。
          </p>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            我们的编辑与内容推荐团队全天候运转，从海量信息中甄别真伪、提炼重点，再以清爽易读的卡片形式呈现在你面前。无论你是资深追星族，还是偶然刷到的路人，都能在这里找到属于自己的那口瓜。
          </p>
          <div className="mt-7 grid gap-4 sm:grid-cols-3">
            {values.map((v) => (
              <div key={v.title} className="rounded-xl bg-background-100 p-4 ring-1 ring-inset ring-background-200">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 text-background-50">
                  <i className={`${v.icon} text-lg`} />
                </span>
                <h3 className="mt-3 text-sm font-semibold text-foreground-900">{v.title}</h3>
                <p className="mt-1 text-xs leading-5 text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
          <Link
            to="/about"
            className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            了解更多 <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}